<div class="details-container d-flex flex-column">
  <button class="d-flex flex-row align-items-center back-btn" (click)="back()">
    <img src="assets/images/svg-icons/left-arrow.svg" alt="back-btn" srcset="" />
    {{"back" | translate | titlecase}}
  </button>
  <div class="details-wrapper">
    <span class="nft-details-title mob-view">
      {{ nftDetails.name }}
      <span>&nbsp;#</span>
      {{ nftDetails.id }}
    </span>
    <tabset type="pills" class="mob-view">
      <!-- <tab [id]="tabIds.CHAIN" (selectTab)="changeTab($event)">
        <ng-template tabHeading>{{ nftDetails.valueInToken.current }}
          {{ nftDetails.valueInToken.symbol }}</ng-template>
      </tab> -->
      <tab [id]="tabIds.USD" (selectTab)="changeTab($event)"><ng-template tabHeading>{{isUSDDefault ?
          CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}}{{
          convertNumToCurr(nftDetails.value.current)
          }}</ng-template>
      </tab>
    </tabset>
    <div class="nft-img-wrapper">
      <div *ngIf="fetchingNFTDetails" class="spinner-overlay">
        <div class="spinner"></div>
      </div>
      <img *ngIf="!fetchingNFTDetails" [src]="nftDetails.imgSrc" class="nft-img" alt="nft-img" />
    </div>
    <div class="nft-details d-flex flex-column gap-sm-3 gap-4">
      <span class="nft-details-title desktop-view">
        {{ nftDetails.name }}
        <span>&nbsp;#</span>{{ nftDetails.id }}
      </span>
      <div class="nft-details-value d-flex flex-column gap-sm-4">
        <tabset type="pills">
          <!-- <tab [id]="tabIds.CHAIN" [active]="activeTabId === tabIds.CHAIN" (selectTab)="changeTab($event)">
            <ng-template tabHeading class="desktop-view">{{ nftDetails.valueInToken.current }}
              {{ nftDetails.valueInToken.symbol }}</ng-template>
            <div class="bar-wrapper d-flex flex-column gap-sm-4 gap-4">
              <span class="price-range-title">Price Range</span>
              <app-range-bar [hasBigFont]="true" [rangeData]="{
                  minPrice: nftDetails.valueInToken.min,
                  maxPrice: nftDetails.valueInToken.max,
                  currentPrice: nftDetails.valueInToken.current,
                  unit: nftDetails.valueInToken.symbol
                }"></app-range-bar>
            </div>
          </tab> -->
          <tab [id]="tabIds.USD" [active]="activeTabId === tabIds.USD" (selectTab)="changeTab($event)"><ng-template
              tabHeading class="desktop-view">{{isUSDDefault ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO}}{{
              convertNumToCurr(nftDetails.value.current)
              }}</ng-template>
            <div class="bar-wrapper d-flex flex-column gap-sm-4 gap-4">
              <span class="price-range-title" translate>price_range</span>
              <app-range-bar [hasBigFont]="true" [rangeData]="{
                  minPrice: nftDetails.value.min,
                  maxPrice: nftDetails.value.max,
                  currentPrice: nftDetails.value.current,
                  unit: isUSDDefault ? CURRENCY_SYMBOL.USD : CURRENCY_SYMBOL.EURO
                }"></app-range-bar>
            </div>
          </tab>
        </tabset>
      </div>
      <div class="nft-intro d-flex flex-column gap-sm-1">
        <ng-container *ngIf="nftDetails.description; else nftDetailsEmptyState">
          <div class="nft-intro-info" [innerHTML]="getDisplayDescription()">
          </div>
          <span *ngIf="nftDetails.description.length > 300" class="read-more-txt cursor-pointer"
            (click)="isSeeMoreExpanded = !isSeeMoreExpanded">{{
            (isSeeMoreExpanded ? "read_less" : "read_more") | translate }}
            <svg-icon [src]="'assets/images/svg-icons/dropdown-arrow-down.svg'"
              [ngClass]="{ 'rotate-arrow': isSeeMoreExpanded }"></svg-icon>
          </span>
        </ng-container>
        <ng-template #nftDetailsEmptyState>
          <span class="nft-intro-info">{{"no_details_found_title" | translate}}</span>
        </ng-template>

      </div>
      <a [href]="nftDetails.openSeaLink" target="_blank"
        class="open-sea-link d-flex flex-row gap-sm-2 align-items-center cursor-pointer">
        <img src="assets/images/svg-icons/blue-link.svg" alt="see-more arrow" class="blue-link-img" />OpenSea
      </a>
      <div class="nft-traits d-flex flex-column gap-sm-4 gap-4">
        <span class="traits-title">{{ "traits" | translate | uppercase }}</span>
        <ng-container *ngIf="nftDetails.traits.length; else nftTraitsEmptyState">
          <div class="nft-trait d-flex flex-column" *ngFor="let trait of nftDetails.traits">
            <span class="trait-type">{{ trait.type | titlecase }}</span>
            <span class="trait-value">{{ trait.value | titlecase }}</span>
          </div>
        </ng-container>
        <ng-template #nftTraitsEmptyState>
          <h6 class="" translate>no_traits_found</h6>
        </ng-template>
      </div>
      <ng-container *ngIf="isLoading">
        <div class="empty-state d-flex flex-column align-items-center justify-content-center gap-sm-4">
          <div class="error-msg title-text d-flex flex-column align-items-center justify-content-center">
            <h3 class="text-center">{{"loading" | translate}}...</h3>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>